<template>
  <section>
    <!-- Video ********************************************************************-->
    <header>
      <!-- <button class='video-solicitud' @click="openModal()">{{ $t('solicitud.showVideo') }}</button> -->
      <a href="https://cancilleria.gob.bo/apostilla/tutoriales/" target="_blank">
        <button class='video-solicitud'>{{ $t('solicitud.showVideo') }}</button>
      </a>
    </header>
    <!-- Modal -->
    <article class="modal" ref="modal" @click="closeModal()">
      <div class="modal-content portada">
        <header><span class="close">&times;</span></header>
        <div class="modal-body">
          <h2 class="title">{{ $t('solicitud.video') }}</h2>

          <iframe v-if="showModal" width="560" height="315" src="https://www.youtube.com/embed/o9kEVAcRz84?autoplay=1" title="Solicitud" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          <p v-html="$t('inicio.modal.important')"></p>
        </div>
      </div>
    </article>
    <!-- End Video ********************************************************************-->

    <h3 class="title text-center">{{ $t('solicitud.title') }}</h3>
    <h3 class="title text-center">{{ $t('solicitud.comunicado') }}</h3>
    <h4 class="title text-center" v-html="$t('solicitud.comunicado1')"></h4>
    <h4 class="title text-center" v-html="$t('solicitud.comunicado3')"></h4>
    <h4 class="title text-center" v-html="$t('solicitud.cambio')"></h4>
    <h4 class="title text-center" v-html="$t('solicitud.comunicado4')"></h4>
    <stepper :steps="steps" :step="step"></stepper>
    <div class="card">
      <div class="card-header">{{ step + 1 }}. {{ steps[step].label }}</div>
      <div class="tabs">
        <form @submit.prevent="solicitar()">
          <div class="card-body grid-form" :class="step == 0? 'active' : ''">
            <div class="grid cols-2">
              <div class="alert alert-info">
                <i class="icon-info"></i> {{$t('fields.info_cont')}}
              </div>
              <div class="alert alert-info">
                <i class="icon-info"></i> <span v-html="$t('solicitud.datos_titular')"></span>
              </div>
            </div>
            <!-- DATOS DEL TITULAR -->
            <div class="grid cols-3">
              <div class="form-group required" :class="{ 'error-input': errors.has('tipoDoc') }">
                <label for="tipo-documento">{{ $t('fields.tipoDoc') }}</label>
                <select
                  class="form-control"
                  id="tipo-documento"
                  name="tipoDoc"
                  maxlength="20"
                  :disabled="!!observado"
                  v-validate="'required'"
                  v-model="form.tipoDoc">
                  <option v-for="(value, key) in tipoDocs" :value="key">{{ value }}</option>
                </select>
                <span v-show="errors.has('tipoDoc')" class="error-help">{{ errors.first('tipoDoc') }}</span>
              </div>
              <div class="form-group required" :class="{ 'error-input': errors.has('nroDoc') }">
                <label for="nro-documento">{{ $t('fields.nroDoc') }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="nro-documento"
                  name="nroDoc"
                  :disabled="!!observado"
                  v-validate="'required'"
                  v-model="form.nroDoc">
                <span v-show="errors.has('nroDoc')" class="error-help">{{ errors.first('nroDoc') }}</span>
              </div>
              <date-select
                :required="true"
                :disabled="!!observado"
                :label="$t('fields.fecha_nacimiento')"
                v-if="dateShow"
                model="solicitud.fecNacimiento"></date-select>
            </div>
            <div v-if="observado">
              <div class="grid">
                <div class="alert alert-info">
                  <i class="icon-info"></i> <strong>Llene</strong> el/los nombre(s), apellido(s) y nacionalidad del
                  <strong>titular del documento manualmente</strong> para poder realizar el trámite de la apostilla.
                </div>
                <!-- <div class="alert alert-warning">
                  <i class="icon-warning"></i> <strong>{{ observado }}</strong>
                </div> -->
              </div>
              <div class="grid cols-4">
                <div class="form-group required" :class="{ 'error-input': errors.has('nombres') }">
                  <label for="nombres">{{ $t('fields.nombres') }}</label>
                  <input
                    type="text"
                    id="nombres"
                    name="nombres"
                    class="form-control"
                    v-validate="'required'"
                    v-model="form.nombres">
                  <span v-show="errors.has('nombres')" class="error-help">{{ errors.first('nombres') }}</span>
                </div>
                <div class="form-group">
                  <label for="primer-ap">{{ $t('fields.primerAp') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="primer-ap"
                    v-model="form.primerAp">
                </div>
                <div class="form-group">
                  <label for="segundo-ap">{{ $t('fields.segundoAp') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="segundo-ap"
                    v-model="form.segundoAp">
                </div>
                <div class="form-group required" :class="{ 'error-input': errors.has('nacionalidad') }">
                  <label for="nacionalidad">{{ $t('fields.nacionalidad') }}</label>
                  <select
                    class="form-control"
                    id="nacionalidad"
                    name="nacionalidad"
                    v-validate="'required'"
                    v-model="form.nacionalidad">
                    <option v-for="item in paises" :value="item.nacionalidad">{{ item.nacionalidad }}</option>
                  </select>
                  <span v-show="errors.has('nacionalidad')" class="error-help">{{ errors.first('nacionalidad') }}</span>
                </div>
              </div>
            </div>
            <!-- DATOS DEL TITULAR END -->
            <div class="grid cols-2">
              <div class="form-group required" :class="{ 'error-input': errors.has('telefono') }">
                <label for="telefono">{{ $t('fields.telefono') }}</label>
                <input
                  type="text"
                  class="form-control"
                  id="telefono"
                  name="telefono"
                  v-validate="'required'"
                  v-model="form.telefono">
                <span v-show="errors.has('telefono')" class="error-help">{{ errors.first('telefono') }}</span>
              </div>
              <div class="form-group required" :class="{ 'error-input': errors.has('email') }">
                <label for="email">{{ $t('fields.email') }}</label>
                <input
                  type="text"
                  placeholder="@"
                  class="form-control"
                  id="email"
                  name="email"
                  v-validate="'required|email'"
                  v-model="form.email">
                <span v-show="errors.has('email')" class="error-help">{{ errors.first('email') }}</span>
              </div>
            </div>
            <div class="btn-container">
              <button class="btn" type="button" @click="cleanForm()" v-if="observado">Cambiar de titular</button>
              <button class="btn" type="button" @click="cancel()">{{ $t('btn.cancel') }} <i
                class="icon-cancel-circle"></i></button>
              <button class="btn btn-primary" type="button" @click="buscarPersona" :disabled="btnNext">
                {{ btnNext ? $t('btn.register') : $t('btn.next') }} <i class="icon-arrow-right2"></i>
              </button>
            </div>
          </div>
          <div class="card-body grid-form"
               :class="step == 1 ? 'active' : ''">
            <div class="grid cols-3">
              <div class="form-group">
                <label for="">{{ $t('fields.tipoDoc') }}</label>
                <p class="form-control">{{ tipoDocs[form.tipoDoc] }} {{ form.tipo ? ' - ' + form.tipo : '' }}</p>
              </div>
              <div class="form-group">
                <label for="">{{ $t('fields.nroDoc') }}</label>
                <p class="form-control">{{ form.nroDoc }}</p>
              </div>
              <div class="form-group">
                <label for="">{{ $t('fields.fecha_nacimiento') }}</label>
                <p class="form-control">{{ $util.formatDate($store.state.solicitud.fecNacimiento) }}</p>
              </div>
            </div>
            <div class="grid cols-2-1" v-show="false">
              <div class="form-group">
                <label for="">{{ $t('fields.nombre_solicitante') }}</label>
                <p class="form-control">{{ form.nombres }} {{ form.primerAp }} {{ form.segundoAp }}</p>
              </div>
              <div class="form-group">
                <label for="">{{ $t('fields.nacionalidad') }}</label>
                <p class="form-control">{{ form.nacionalidad }}</p>
              </div>
            </div>
            <div class="alert alert-info">
              <i class="icon-info"></i> {{ $t('fields.info_agregar') }}
            </div>

            <div class="form-group">
              <label>Descripción de la entidad</label>
              <select class="form-control" v-model="form.id_entidad">
                <option value="">Seleccione una entidad</option>
                <option v-for="(item, key) in entidades" :value="item.entidad_codigo_portal">
                  {{item.entidad_nombre}} - {{item.entidad_sigla}}
                </option>
              </select>
            </div>

            <div class="grid add-document">

              <div class="form-group required">
                <label for="">{{ $t('fields.desc_doc') }}</label>
                <select class="form-control" v-model="form.id_documento">
                  <option value="">{{ $t('fields.select_doc') }}</option>
                  <option v-for="(item, key) in documentosDeEntidad" :value="item.id">
                    {{item.nombre}}
                  </option>
                </select>
              </div>
              <div class="form-group required">
                <label for="">{{ $t('fields.precio') }}</label>
                <input
                  type="text"
                  class="form-control text-right"
                  disabled
                  v-model="precio"
                  placeholder="0">
              </div>
              <div class="form-group">
                <label>&nbsp;</label>
                <button
                  class="btn btn-success"
                  title="Agregar documento"
                  type="button" @click="add()">
                  <i class="icon-plus"></i> Agregar
                </button>
              </div>
            </div>
            <div class="documentos">
              <h4 class="title"> {{$t('fields.mis_doc')}} {{ docsSolicitud.length ? ` - Total: ${docsSolicitud.length}`
                : '' }}</h4>
              <div class="alert alert-warning" v-if="docsSolicitud.length === 0">
                <i class="icon-warning"></i> {{$t('fields.alert_doc')}}
              </div>
              <div class="alert alert-info" v-else>
                <!--<i class="icon-info"></i> Seleccione si quiere que su documento apostillado sea <strong>Impreso</strong>
                en el Ministerio de Relaciones Exteriores o <strong>Digital</strong> que lo puede descargar cuando
                quiera y en cualquier lugar.-->
                <i class="icon-info"></i> La apostilla es <strong>digital</strong>, puede descargarla cuando requiera y
                en cualquier lugar.
              </div>
              <div v-if="docsSolicitud.length" class="documentos">
                <div class="documento" v-for="(item, index) in docsSolicitud">
                  <h5 class="title-documento">{{ index + 1 }}. {{ item.nombre }}</h5>
                  <!--<p>{{ item.descripcion }}</p>-->
                  <p class="entidad">
                    <small><strong v-if="item.entidad_sigla">{{ item.entidad_sigla }} - </strong>{{ item.entidad_nombre
                      }}
                    </small>
                  </p>
                  <div class="opciones">
                    <!--<div class="md-radio-container">
                      <div class="md-radio md-radio-inline">
                        <input :id="'d' + index" type="radio" v-model="item.tipo" :name="'r' + index" value="DIGITAL"
                               checked>
                        <label :for="'d' + index">Digital</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input :id="'i' + index" type="radio" v-model="item.tipo" :name="'r' + index" value="IMPRESO">
                        <label :for="'i' + index">Impreso</label>
                      </div>
                    </div>-->
                    <button
                      class="btn btn-danger btn-small"
                      type="button"
                      title="Eliminar"
                      @click="remove(index)">
                      <i class="icon-bin"></i> Eliminar
                    </button>
                    <div class="precio">Costo: <strong>{{ item.monto[0].monto || 0 }}</strong> Bs.</div>
                  </div>

                  <div v-for="(item1, i) in camposExtra[index]">
                    <div v-if="item1.type === 'text'" class="grid cols-3-1">
                      <span></span>
                      <label>{{ item1.nombre }}</label>
                      <input
                        type="text"
                        v-bind:placeholder="item1.label"
                        class="form-control"
                        :disabled="item1.disabled"
                        @change="llenar(camposExtra[index])"
                        v-model="camposExtra[index][i].value">
                    </div>
                    <div v-if="item1.type === 'select'" class="grid cols-3-1">
                      <span></span>
                      <span>{{ item1.nombre }}</span>
                      <select
                        v-model="camposExtra[index][i].value"
                        class="form-control"
                        name="categorias"
                        v-validate="'required'">
                        <option v-for="(item2) in item1.opciones">{{ item2.value }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="total">
                  <!-- <p>{{$t('fields.costo_doc')}}: <strong>{{ totalDocs }}</strong> <small>Bs.</small></p>
                  <p>{{$t('fields.costo_apostilla')}}: <strong>{{ totalApostilla }}</strong> <small>Bs.</small></p>
                  <hr> -->
                  <p>Costo total: <strong>{{ (totalDocs || 0) + (totalApostilla || 0) }}</strong>
                    <small>Bs.</small>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div class="alert alert-info">
                <i class="icon-info"></i> Seleccione el departamento donde realiza su trámite
              </div>
              <div class="form-group required" :class="{ 'error-input': errors.has('regional') }">
                <label for="regional">{{ $t('fields.regional') }}</label>
                <select
                  class="form-control"
                  id="regional"
                  name="regional"
                  v-model="form.regional">
                  <option v-for="item in regionales" :value="item">{{ item }}</option>
                </select>
                <span v-show="errors.has('regional')" class="error-help">{{ errors.first('regional') }}</span>
              </div>
            </div>
            <h5 class="title title-titular">
              <!-- <span>¿Es Usted el Titular de los documentos a apostillar o es un Tramitador?</span> -->
              <div class="md-radio-container">
                <div class="md-radio md-radio-inline">
                  <input id="titular-si" type="radio" v-model="form.titular" name="titular" value="TITULAR" checked>
                  <label for="titular-si">TITULAR</label>
                </div>
               <!-- <div class="md-radio md-radio-inline">
                  <input id="titular-no" type="radio" v-model="form.titular" name="titular" value="TRAMITADOR">
                  <label for="titular-no">SOY REPRESENTANTE</label>
                </div> -->
              </div>
            </h5>

            <!-- DATOS DEL TRAMITADOR -->
            <div v-if="form.titular == 'TRAMITADOR'">
              <div class="grid cols-2">
                <div class="alert alert-info">
                  <i class="icon-info"></i> Ingrese los datos del tramitador y valide que estos se encuentren
                  registrados en el SEGIP o Migración.
                </div>
                <div class="alert alert-info">
                  <i class="icon-info"></i> <strong>Datos del tramitador.-</strong> Es la persona que va a realizar el
                  trámite de la apostilla en representación del titular del documento.
                </div>
              </div>
              <div class="grid cols-3-1">
                <div class="form-group required" :class="{ 'error-input': errors.has('tramitador_tipoDoc') }">
                  <label for="tramitador-tipo-documento">{{ $t('fields.tipoDoc') }}</label>
                  <select
                    class="form-control"
                    id="tramitador-tipo-documento"
                    name="tramitador_tipoDoc"
                    :disabled="validado"
                    v-validate="'required'"
                    v-model="form.tramitador_tipoDoc">
                    <option v-for="(value, key) in tipoDocs" :value="key">{{ value }}</option>
                  </select>
                  <span v-show="errors.has('tramitador_tipoDoc')" class="error-help">{{ errors.first('tramitador_tipoDoc') }}</span>
                </div>
                <div class="form-group required" :class="{ 'error-input': errors.has('tramitador_nroDoc') }">
                  <label for="tramitador-nro-documento">{{ $t('fields.nroDoc') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="tramitador-nro-documento"
                    name="tramitador_nroDoc"
                    :disabled="validado"
                    v-validate="'required'"
                    maxlength="20"
                    v-model="form.tramitador_nroDoc">
                  <span v-show="errors.has('tramitador_nroDoc')" class="error-help">{{ errors.first('tramitador_nroDoc') }}</span>
                </div>
                <date-select
                  :required="true"
                  :disabled="validado"
                  :label="$t('fields.fecha_nacimiento')"
                  v-if="tramitadorDateShow"
                  model="solicitud.tramitador_fecNacimiento"></date-select>
                <div>
                  <div><span v-if="validado"><i class="icon-checkmark"></i> VALIDADO</span></div>
                  <button class="btn btn-search" type="button" @click="cambiar" v-if="validado">Cambiar</button>
                  <button class="btn btn-success btn-search" type="button" @click="validar" :disabled="btnValidar"
                          v-else>
                    <i class="icon-search"></i> {{ btnValidar ? 'Validando' : 'Validar' }}
                  </button>
                </div>
              </div>
              <div class="grid cols-2" v-if="tramitadorObservado">
                <div class="alert alert-info">
                  <i class="icon-info"></i> <strong>Llene</strong> el/los nombre(s), apellido(s) y nacionalidad del
                  <strong>titular del documento manualmente</strong> para poder realizar el trámite de la apostilla.
                </div>
                <div class="alert alert-warning">
                  <i class="icon-warning"></i> <strong>{{ tramitadorObservado }}</strong>
                </div>
              </div>
              <div class="grid cols-3" v-if="validado && tramitadorObservado">
                <div class="form-group required" :class="{ 'error-input': errors.has('tramitador_nombres') }">
                  <label for="tramitador_nombres">{{ $t('fields.nombres') }}</label>
                  <input
                    type="text"
                    id="tramitador_nombres"
                    name="tramitador_nombres"
                    class="form-control"
                    :disabled="!tramitadorObservado"
                    v-validate="'required'"
                    v-model="form.tramitador_nombres">
                  <span v-show="errors.has('tramitador_nombres')" class="error-help">{{ errors.first('tramitador_nombres') }}</span>
                </div>
                <div class="form-group">
                  <label for="primer-ap">{{ $t('fields.primerAp') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="!tramitadorObservado"
                    id="tramitador-primer-ap"
                    v-model="form.tramitador_primerAp">
                </div>
                <div class="form-group">
                  <label for="segundo-ap">{{ $t('fields.segundoAp') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="!tramitadorObservado"
                    id="tramitador-segundo-ap"
                    v-model="form.tramitador_segundoAp">
                </div>
              </div>
            </div>
            <!-- DATOS DEL TRAMITADOR FIN -->

            <div class="btn-container">
              <button class="btn" type="button" @click="cancel()">{{ $t('btn.cancel') }} <i class="icon-blocked"></i>
              </button>
              <button class="btn" type="button" @click="prev(0)">{{ $t('btn.prev') }} <i class="icon-arrow-left2"></i>
              </button>
              <button class="btn btn-primary" type="button" @click="nextPagos()" :disabled="btnNext">
                {{ btnNext ? $t('btn.register') : $t('btn.next') }} <i class="icon-arrow-right2"></i>
              </button>
            </div>


            <!-- <div class="btn-container btn-margin">
              <button class="btn" type="button" @click="cancel">{{ $t('btn.cancel') }} <i class="icon-blocked"></i></button>
              <button class="btn" type="button" @click="prev">{{ $t('btn.prev') }} <i class="icon-arrow-left2"></i></button>
              <button class="btn btn-primary" type="submit" :disabled="btnSolicitar">
                {{ btnSolicitar ? $t('btn.solicitando') : $t('btn.solicitar') }} <i class="icon-checkmark"></i>
              </button>
            </div> -->

          </div>
          <div class="card-body" :class="step == 2 ? 'active' : ''">
            <!--<div class="alert alert-info">
              <i class="icon-info"></i> Diligencie los datos de pago. El titular del pago puede ser distinto al titular
              del documento.
            </div>-->

            <div class="card documentos pago-total">
              <div class="total">
                <!-- <p>Costo total de los documentos de las entidades: <strong>{{ totalDocs }}</strong> <small>Bs.</small></p>
                <p>Costo de la apostilla ({{ costoApostilla }} <small>Bs.</small>) x {{ docsSolicitud.length }}: <strong>{{ totalApostilla }}</strong> <small>Bs.</small></p>
                <hr> -->
                <p class="text-center">Costo total: <strong>{{ totalDocs + totalApostilla }}</strong>
                  <small>Bs.</small>
                </p>
              </div>
            </div>

            <h4 class="title">Deseo recoger mi factura de las oficinas de:</h4>
            <!--<h4 class="title">Ingrese sus datos para la factura</h4>-->
            <!--<div class="form-group-radios">-->
            <!--<label for="titular-si"><input type="radio" id="titular-si" value="SI"v-model="titular" name="titular"> SI</label>-->
            <!--<label for="titular-no"><input type="radio" id="titular-no" value="NO"v-model="titular" name="titular"> NO</label>-->
            <!--</div>-->


            <div class="grid cols-3" v-if="step == 2">
              <!--<div class="grid cols-3" v-if="titular">-->
              <!-- <div class="form-group required" :class="{ 'error-input': errors.has('factura_tipo_documento') }">
                <label>Tipo de documento</label>
                <select
                  class="form-control"
                  name="factura_tipo_documento"
                  v-validate="'required'"
                  v-model="form.factura_tipo_documento">
                  <option value="">Seleccione...</option>
                  <option v-for="(value, key) in tipoDocs" :value="key">{{ value }}</option>
                </select>
                <span v-show="errors.has('factura_tipo_documento')" class="error-help">{{ errors.first('factura_tipo_documento') }}</span>
              </div> -->
              <!--<div class="form-group required" :class="{ 'error-input': errors.has('factura_titular_factura') }">
                <label>SEÑOR(ES)</label>
                <input
                  type="text"
                  name="factura_titular_factura"
                  class="form-control"
                  v-validate="'required'"
                  v-model="form.factura_titular_factura">
                <span v-show="errors.has('factura_titular_factura')" class="error-help">{{ errors.first('factura_titular_factura') }}</span>
              </div>
              <div class="form-group required" :class="{ 'error-input': errors.has('factura_nro_documento') }">
                <label>NIT/CI</label>
                <input
                  type="text"
                  name="factura_nro_documento"
                  class="form-control"
                  v-validate="'required'"
                  v-model="form.factura_nro_documento">
                <span v-show="errors.has('factura_nro_documento')" class="error-help">{{ errors.first('factura_nro_documento') }}</span>
              </div>-->
              <div class="form-group required" :class="{ 'error-input': errors.has('factura_regional_factura') }">
                <label>Regional</label>
                <select class="form-control" name="factura_regional_factura" v-validate="'required'" v-model="form.factura_regional_factura">
                  <option value="">Seleccione una regional</option>
                  <option v-for="item in regionalesFactura" :value="item">{{ item }}</option>
                </select>
                <span v-show="errors.has('factura_regional_factura')" class="error-help">{{ errors.first('factura_regional_factura') }}</span>
              </div>
            </div>
            <div class="btn-container">
              <button class="btn" type="button" @click="cancel()" :disabled="btnSolicitar">{{ $t('btn.cancel') }} <i
                class="icon-blocked"></i></button>
              <button class="btn" type="button" @click="prev(1)" :disabled="btnSolicitar">{{ $t('btn.prev') }} <i
                class="icon-arrow-left2"></i></button>
              <button class="btn btn-primary" type="submit" :disabled="btnSolicitar">
                {{ btnSolicitar ? $t('btn.solicitando') : $t('btn.solicitar') }} <i class="icon-checkmark"></i>
              </button>
            </div>
          </div>
        </form>
        <div class="card-body" :class="step == 3 ? 'active' : ''">
          <div class="alert alert-success"><i class="icon-checkmark"></i> {{ $t('fields.fin_solicitud') }}</div>
          <div class="text-center">
            <p class="finalizado">
              {{$t('fields.cod_seguimiento')}} <span class="codigo-text">{{ codigo }}</span>
            </p>
          </div>
          <div class="alert alert-info">
            <i class="icon-info"></i> <strong>{{$t('fields.guardar_codigo')}}</strong>{{$t('fields.seguimiento_codigo')}}<strong>
            <router-link to="/seguimiento">{{$t('fields.aqui')}}</router-link>
          </strong>.
          </div>
          <div class="pagos" v-if="pagos.length">
            <h4 class="title">Boletas de pago</h4>
            <div class="alert alert-info">
              <i class="icon-info"></i> <strong>Guarde e imprima</strong> esta(s) boleta(s) de pago para continuar con
              su solicitud. Si Ud. ingresó un correo electrónico en la solicitud se le enviará estas boletas de pago a
              su correo electrónico.
            </div>
            <div class="alert alert-danger">
              <strong>IMPORTANTE.-</strong> Si no registró un correo electrónico en la solicitud y no guardo o imprimio
              esta(s) boleta(s) de pago, estas boletas desaparecerán de esta pantalla y no podrá recuperarlas por lo
              tanto deberá hacer de nuevo su solicitud.
            </div>
            <div class="pagos-documento" v-for="item in pagos">
              <div class="pagos-info">
                <p><strong>Documento:</strong> {{ item.documento.nombre }} Nro. {{item.id}}</p>
              </div>
              <pdf-view :data="item.pdf" :storage="item.id" :id="item.id"></pdf-view>
            </div>
          </div>
          <!-- <div class="btn-container">
            <button class="btn btn-primary" type="button" @click="finish()">{{ $t('btn.finalizar') }} <i class="icon-checkmark2"></i></button>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Stepper from '@/components/util/Stepper';
  import DateSelect from '@/components/util/DateSelect';
  import Location from '@/components/util/Location';
  import documentos from '@/components/pages/mixins/documentos';
  import paises from '@/components/pages/mixins/paises';
  import PdfView from '@/components/util/PdfView';

  const tipoDocs = {
    CI: 'CÉDULA DE IDENTIDAD',
    PASAPORTE: 'PASAPORTE'
  };

  const regionales = ['BENI', 'CHUQUISACA', 'COCHABAMBA', 'LA PAZ', 'ORURO', 'PANDO', 'POTOSI', 'SANTA CRUZ', 'TARIJA'];
  const regionalesFactura = ['LA PAZ', 'COCHABAMBA', 'SANTA CRUZ'];

  export default {
    mixins: [documentos, paises],
    mounted () {
      this.getDocumentos(false);
      this.getEntidades();
      // this.getCostoApostilla();

      this.paises = this.getPaises();
      window.localStorage.clear();
    },
    data () {
      return {
        showModal: false,
        steps: [
          {label: this.$t('fields.info_sol')},
          {label: this.$t('fields.info_doc')},
          {label: 'DATOS DE PAGO'},
          {label: this.$t('fields.info_finalizado')}
        ],
        step: 0,
        dateShow: true,
        tramitadorDateShow: true,
        regionales,
        regionalesFactura,
        documentos: [],
        documentosDeEntidad: [],
        entidades: [],
        paises: [],
        observado: false,
        tramitadorObservado: false,
        form: {
          tipoDoc: 'CI',
          nroDoc: '',
          nombres: '',
          primerAp: '',
          segundoAp: '',
          telefono: '',
          email: '',
          tipo: null,
          regional: null,
          nacionalidad: 'BOLIVIANA',
          id_documento: '',
          id_entidad: '',
          titular: 'TITULAR',
          tramitador_tipoDoc: 'CI',
          tramitador_nroDoc: '',
          tramitador_nombres: '',
          tramitador_primerAp: '',
          tramitador_segundoAp: '',
          factura_tipo_documento: '',
          factura_titular_factura: '',
          factura_nro_documento: '',
          factura_regional_factura: ''
        },
        precio: '',
        monto: '',
        error: {
          contacto: false
        },
        docsSolicitud: [],
        camposExtra: [],
        codigo: '',
        btnNext: false,
        btnValidar: false,
        btnSolicitar: false,
        titular: 'SI',
        costoApostilla: 0,
        validado: false,
        tipoDocs,
        pagos: []
      };
    },
    methods: {
      getNacionalidad (pais) {
        for (let i in this.paises) {
          if (this.paises[i].pais === pais) {
            return this.paises[i].nacionalidad;
          }
        }
        return pais;
      },
      async buscarPersona () {
        this.$store.commit('setValid', true);
        if (await this.$validator.validateAll() && !this.$filter.empty(this.$store.state.solicitud.fecNacimiento) && !this.btnNext) {
          let doc = this.getNroDocumento(this.form.nroDoc);
          let data = {
            tipoDoc: this.form.tipoDoc,
            nroDoc: doc.nroDocumento,
            fecNacimiento: this.$util.formatDate(this.$store.state.solicitud.fecNacimiento),
            complemento: doc.complemento
          };
          if (!this.observado) {
            this.btnNext = true;
            // this.$service.post('registrar-datos', data)
            //   .then(response => {
            //     this.btnNext = false;
            //     if (response) {
            //       if (response.observacion) {
            //         this.observado = response.observacion;
            //       } else {
            //         this.observado = false;
            //         this.form.nombres = response.nombres;
            //         this.form.primerAp = response.paterno;
            //         this.form.segundoAp = response.materno;
            //         this.form.nacionalidad = this.form.tipoDoc === 'CI' ? this.getNacionalidad(response.nacionalidad) : response.nacionalidad;
            //         this.form.tipo = response.tipo;
            //         this.step = 1;

            //         data.fecNacimiento = this.$store.state.solicitud.fecNacimiento;
            //         data.email = this.form.email;
            //         data.telefono = this.form.telefono;
            //         data.nombres = this.form.nombres;
            //         data.primerAp = this.form.primerAp;
            //         data.segundoAp = this.form.segundoAp;
            //         data.nacionalidad = this.form.nacionalidad;

            //         this.$store.commit('setSolicitud', data);
            //       }
            //     }
            //   });
            // ---------------------------- Sin Solicitud ----------------------------
            this.btnNext = false;
            this.observado = {observacion: 'Observado'};
          } else {
            this.step = 1;
            this.form.tipo = null;
            data.fecNacimiento = this.$store.state.solicitud.fecNacimiento;
            data.email = this.form.email;
            data.telefono = this.form.telefono;
            data.nombres = this.form.nombres;
            data.primerAp = this.form.primerAp;
            data.segundoAp = this.form.segundoAp;
            data.nacionalidad = this.form.nacionalidad;
            if (typeof this.observado === 'string' && !this.$filter.empty(this.observado)) {
              data.observacion = this.observado;
            }
            this.$store.commit('setSolicitud', data);
            // ---------------------------- Sin Solicitud End----------------------------
          }
        }
      },
      async validar () {
        this.$store.commit('setValid', true); // TODO: Esto valida la fecha de nacimiento del titular del documento y no del tramitador
        if (await this.$validator.validate('tramitador_nroDoc') && !this.btnValidar) {
          let fechaNac = this.$store.state.solicitud.tramitador_fecNacimiento;
          if (this.$filter.empty(fechaNac)) {
            this.$message.warning('Ingresa la fecha de nacimiento del tramitador');
            return false;
          }
          let doc = this.getNroDocumento(this.form.tramitador_nroDoc);
          let data = {
            tipoDoc: this.form.tramitador_tipoDoc,
            nroDoc: doc.nroDocumento,
            fecNacimiento: this.$util.formatDate(fechaNac),
            complemento: doc.complemento
          };
          this.btnValidar = true;
          this.form.tramitador_nombres = '';
          this.form.tramitador_primerAp = '';
          this.form.tramitador_segundoAp = '';
          this.$service.post('registrar-datos', data)
            .then(response => {
              this.btnValidar = false;
              if (response) {
                this.validado = true;
                if (response.observacion) {
                  this.tramitadorObservado = response.observacion;
                } else {
                  this.tramitadorObservado = false;
                  this.form.tramitador_nombres = response.nombres;
                  this.form.tramitador_primerAp = response.paterno;
                  this.form.tramitador_segundoAp = response.materno;

                  let data = Object.assign({}, this.$store.state.solicitud, {
                    tramitador_tipoDoc: this.form.tramitador_tipoDoc,
                    tramitador_nroDoc: this.form.tramitador_nroDoc,
                    tramitador_nombres: this.form.tramitador_nombres,
                    tramitador_primerAp: this.form.tramitador_primerAp,
                    tramitador_segundoAp: this.form.tramitador_segundoAp
                  });
                  this.$store.commit('setSolicitud', data);
                }
              }
            });
        }
      },
      async llenar (camposExtra) {
        let data = {
          matricula: camposExtra[0].value,
          apPaterno: camposExtra[1].value,
          apMaterno: camposExtra[2].value
        };

        this.$service.post('obtener-formacion-academica', data)
          .then(response => {
            // alert('response: ' + JSON.stringify(response));

            if (response.length !== 0) {
              let opciones = [];
              for (const i in response) { // campos extra
                opciones.push({'value': response[i].titulo});
              }
              // alert('opciones nuevas: ' + JSON.stringify(opciones));

              camposExtra.splice(3, 1);
              camposExtra.push({nombre: 'Categorias', type: 'select', opciones: opciones});
            } else {
              camposExtra.splice(3, 1);
              camposExtra.push({nombre: 'Categorias', type: 'text', value: 'No tiene categoria', disabled: true});
            }
          });

        /* axios.get(`http://test.agetic.gob.bo/kong/fake/sirepro/v1/matriculas/A-93/formacionesAcademicas?apPaterno=${camposExtra[0].value}&apMaterno=${camposExtra[1].value}`)
          .then(response => {
            alert('response: ' + JSON.stringify(response.data));
            let opciones = [];
            for (const i in response) { // campos extra
              opciones.push({'value': response[i].titulo});
            }
            // alert('opciones nuevas: ' + JSON.stringify(opciones));
            camposExtra.push({nombre: 'categorias', type: 'select', opciones: opciones});
          })
          .catch(error => {
            alert('Error! : ' + JSON.stringify(error));
          }); */
      },
      async nextPagos () {
        if (this.docsSolicitud.length === 0) {
          this.$message.warning('Tiene que agregar por lo menos un documento para ser Apostillado');
        } else {
          if (!this.form.regional) {
            this.$message.warning('Tiene que escoger el departamento donde se realiza el trámite');
            return false;
          }

          if (await this.$validator.validateAll()) {
            if (this.form.titular === 'TRAMITADOR' && !this.validado) {
              this.$message.warning('Debe validar el número de documento y fecha de nacimiento del tramitador');
              return false;
            }

            this.step = 2;
          }
          // this.setTitular();
        }
      },
      async solicitar () {
        if (this.btnSolicitar) return false;

        if (this.docsSolicitud.length === 0) {
          this.$message.warning('Tiene que agregar por lo menos un documento para ser Apostillado');
          return false;
        }

        if (await this.$validator.validateAll()) {
          if (this.form.titular === 'TRAMITADOR' && !this.validado) {
            this.$message.warning('Debe validar el número de documento y fecha de nacimiento del tramitador');
            return false;
          }

          this.$modal.confirm(this.$t('fields.confirmacion_solicitud'), () => {
            this.btnSolicitar = true;
            let data = Object.assign({}, this.$store.state.solicitud);
            data.tipoSolicitante = this.form.titular;
            data.regional = this.form.regional;
            delete data.mensaje;

            let docs = [];
            this.docsSolicitud.map(item => {
              // docs.push({id: item.id, digital: item.tipo === 'DIGITAL', codigo_portal: item.codigo_portal});
              docs.push({id: item.id, digital: true, codigo_portal: item.codigo_portal});
            });

            for (const key in this.camposExtra) {
              docs[key].otros = this.camposExtra[key];
            }// añadiendo los campos extra a los documentos seleccionados

            // data.nombreFactura = this.form.nombreFactura;
            // data.docFactura = this.form.docFactura;
            // data.tipoFactura = 'NIT'; // valor por defecto
            data.documentos = docs;

            if (this.form.titular === 'TRAMITADOR' && typeof this.tramitadorObservado === 'string' && !this.$filter.empty(this.tramitadorObservado)) {
              data.tramitador_tipoDoc = this.form.tramitador_tipoDoc;
              data.tramitador_nroDoc = this.form.tramitador_nroDoc;
              data.tramitador_nombres = this.form.tramitador_nombres || data.tramitador_nombres;
              data.tramitador_primerAp = this.form.tramitador_primerAp || data.tramitador_primerAp;
              data.tramitador_segundoAp = this.form.tramitador_segundoAp || data.tramitador_segundoAp;
              data.tramitador_observacion = this.tramitadorObservado;
            }

            data.factura_tipo_documento = 'CI';
            data.observacion = 'observado DIGEMIG';
            data.factura_titular_factura = this.form.factura_titular_factura;
            data.factura_nro_documento = this.form.factura_nro_documento;
            data.factura_regional_factura = this.form.factura_regional_factura;

            this.$service.post('registrar', data)
              .then(response => {
                this.btnSolicitar = false;
                if (response) {
                  this.codigo = response.cod_seguimiento;
                  this.pagos = response.pagos;
                  this.step = 3;

                  this.cleanForm();
                }
              });
          });
        }
      },
      cleanForm () {
        this.observado = false;
        this.form = {
          tipoDoc: 'CI',
          nroDoc: '',
          nombres: '',
          primerAp: '',
          segundoAp: '',
          telefono: '',
          email: '',
          nacionalidad: '',
          id_documento: '',
          tipo: null,
          regional: null,
          tramitador_tipoDoc: 'CI',
          tramitador_nroDoc: '',
          tramitador_nombres: '',
          tramitador_primerAp: '',
          tramitador_segundoAp: '',
          titular: 'TITULAR',
          validado: false
        };
        this.$store.commit('setSolicitud', {});
        this.dateShow = false;
        this.$nextTick(() => {
          this.dateShow = true;
        });
      },
      cambiar () {
        this.validado = false;
        this.tramitadorObservado = false;
      },
      cleanFormTramitador () {
        this.tramitadorObservado = false;
        this.validado = false;
        this.form = {
          tramitador_tipoDoc: 'CI',
          tramitador_nroDoc: '',
          tramitador_nombres: '',
          tramitador_primerAp: '',
          tramitador_segundoAp: ''
        };
        this.tramitadorDateShow = false;
        this.$nextTick(() => {
          this.tramitadorDateShow = true;
        });
      },
      add () {
        if (!this.$filter.empty(this.form.id_documento)) {
          if (this.docsSolicitud.length < 10) {
            let doc = this.docs.filter(item => item.id === this.form.id_documento);

            doc = Object.assign({}, doc[0]);
            doc.tipo = 'DIGITAL';
            this.docsSolicitud.push(doc);

            let otros = [];
            for (const i in doc.otros) { // campos extra
              otros.push({'nombre': doc.otros[i].nombre, 'label': doc.otros[i].label, 'type': doc.otros[i].type});
            }
            this.camposExtra.push(otros);
          } else {
            this.$message.warning('Solo puede pedir un máximo de 10 documentos por solicitud.');
          }
        } else {
          this.$message.warning('Debe seleccionar un documento para agregarlo a su solicitud.');
        }
      },
      remove (index) {
        this.docsSolicitud = this.docsSolicitud.filter((item, i) => i !== index);
        this.camposExtra = this.camposExtra.filter((item, i) => i !== index);
      },
      prev (step = 0) {
        this.observado = false;
        this.form.titular = 'TITULAR';
        this.step = step;
      },
      finish () {
        this.$router.push('/');
      },
      cancel () {
        this.$modal.confirm('¿Está seguro que quiere cancelar su solicitud de apostilla?', () => {
          this.$router.push('/');
        });
      },
      getPrecio (id) {
        let doc = this.docs.filter(item => item.id === id);
        if (doc[0]) {
          doc = doc[0];
          if (doc.monto && doc.monto[0] && doc.monto[0].monto) {
            return doc.monto[0].monto;
          }
        }
        return 0;
      },
      getCostoApostilla () {
        this.$service.get('costo')
          .then(response => {
            if (response) {
              this.costoApostilla = parseFloat(response.valor);
            }
          });
      },
      // setTitular () {
      //   this.form.nombreFactura = `${this.form.primerAp} ${this.form.segundoAp} ${this.form.nombres}`;
      //   this.form.tipoFactura = this.form.tipoDoc;
      //   this.form.docFactura = this.form.nroDoc;
      // },
      getNroDocumento (nroDoc) {
        let nroDocumento = nroDoc.split('-');
        let complemento;
        if (nroDocumento.length > 1) {
          complemento = nroDocumento[1].trim();
          nroDocumento = nroDocumento[0].trim();
        } else {
          nroDocumento = nroDoc.trim();
        }
        return {
          nroDocumento,
          complemento
        };
      },
      // Modal ********************************************************************
      openModal () {
        this.showModal = true;
        this.$refs.modal.style.display = 'block';
      },
      closeModal () {
        this.showModal = false;
        this.$refs.modal.style.display = 'none';
      }
    },
    computed: {
      totalApostilla () {
        let total = 0;
        this.docsSolicitud.map(documento => {
          total += documento.monto[0].monto;
        });
        return total;
      },
      totalDocs () {
        // if (this.docsSolicitud.length) {
        //   let total = 0;
        //   this.docsSolicitud.map(item => (total += item.precio));
        //   return total;
        // }
        return 0;
      },
      verificarImpreso () {
        for (let i in this.docsSolicitud) {
          if (this.docsSolicitud[i].tipo === 'IMPRESO') {
            return true;
          }
        }
        return false;
      }
    },
    components: {
      Stepper,
      DateSelect,
      Location,
      PdfView
    },
    watch: {
      'form.id_entidad': function (val) {
        this.form.id_documento = '';
        this.documentosDeEntidad = this.documentos.filter(value => {
          if (value.entidad_codigo_portal === val) {
            return value;
          }
        });
      },
      'form.id_documento': function (val) {
        if (!this.$filter.empty(val)) {
          this.precio = this.getPrecio(val) + ' Bs.';
        } else {
          this.precio = '';
        }
      },
      '$store.state.lang': function () {
        this.steps = [
          {label: this.$t('fields.info_sol')},
          {label: this.$t('fields.info_doc')},
          {label: 'DATOS DE PAGO'},
          {label: this.$t('fields.info_finalizado')}
        ];
      }
    }
  };
</script>

<style lang="scss">
  @import 'pages.scss';

  .title-documento {
    width: 550px;
    font-family: 'Abel';
    font-weight: 400;
  }

  .title-titular {
    margin: 30px 0 20px 0;

    span {
      margin-right: 20px;
    }

    .md-radio {
      margin: 0;
    }
  }

  .btn-search {
    margin-top: 10px;
  }

  .btn-margin {
    margin-top: 50px;
  }

  .md-radio-container {
    display: inline-block;
  }

  .grid {
    &.add-document {
      grid-template-columns: 8fr 1fr 1fr;
    }
  }

  .form-group-radios {
    margin: 15px 0 25px;

    label {
      display: inline-block;
      margin-left: 15px;
    }
  }

  .pago-total {
    max-width: 500px;
    margin: 0 auto 20px;
  }

  @media (max-width: 768px) {
    .documentos .documento .opciones {
      position: static;
      margin-top: 10px;
      text-align: center;
    }

    .title-titular {
      .md-radio-inline {
        margin-bottom: 10px;
      }
    }
  }

// Modal ---------------------------------
.video-solicitud {
  padding: 5px 15px;
  background: #ff9300;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.video-solicitud:hover {
  background: #ffaa36;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 30; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.modal-content header {
  padding: 0px 20px;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

/* The Close Button */
.close {
  color: #000;
  float: right;
  font-size: 36px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  text-decoration: none;
  cursor: pointer;
  color: #707070
}

.modal-body {padding: 20px; text-align: center;}

@media (max-width: 868px) {
  .modal-content {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Solicitud.vue